import { render } from "./icon-success.vue?vue&type=template&id=08e9547e"
import script from "./icon-success.vue?vue&type=script&lang=js"
export * from "./icon-success.vue?vue&type=script&lang=js"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__